import React, { memo, useState, Fragment } from 'react';

import { trans } from '../../localization';

import { MIGRATE_ACTION } from './const';

import NowCheckbox from '../Common/NowCheckbox';
import MigrationModal, { MigrationSettingModal } from './MigrationModal';

import MailBoxBgIcon from '../../assets/common/svg/mailbox-bg.svg';
import MailBoxIcon from '../../assets/common/svg/mailbox.svg';

import './MigrationConfirmModal.scss';

const MigrationConfirmModal = memo(props => {
  const [isManagerWranOpen, setIsManagerWranOpen] = useState(false);
  const [isStaffWranOpen, setIsStaffWranOpen] = useState(false);
  const [isReaded, setIsReaded] = useState(true);

  const {
    isOpen,
    closable,
    setIsOpen,
    isConfirmOpen,
    setIsConfirmOpen,
    migrateAction,
    managerList,
    restaurantId,
    restaurantName,
    onConfirm,
    onClose,
  } = props;

  function handleClose() {
    setIsOpen(false);
    onClose();

    if (migrateAction === MIGRATE_ACTION.NOTICE_MANAGER) {
      setIsStaffWranOpen(true);
    } else {
      setIsManagerWranOpen(true);
    }
  }

  function handleManagerWranConfirm() {
    setIsManagerWranOpen(false);
    setIsOpen(true);
  }

  function handleManagerWranCancel() {
    setIsManagerWranOpen(false);
  }

  function handleStaffWranConfirm() {
    setIsStaffWranOpen(false);
  }

  function handleConfirmSuccessConfirm() {
    setIsConfirmOpen(false);
  }

  const renderForStaff = () => (
    <Fragment>
      <div className="migration-confirm-modal-notice">
        {trans('merchant_migration_dialog_text_tellManager')}
      </div>
      <div className="migration-confirm-modal-manager-list">
        {managerList.map(({ avatar_url: avatarUrl, name, email, phone }) => (
          <div className="migration-confirm-modal-manager-item">
            <img
              className="migration-confirm-modal-manager-profile"
              src={avatarUrl}
              alt=""
            />
            <div className="migration-confirm-modal-manager-msg">
              <div className="migration-confirm-modal-manager-name">{name}</div>
              {email && (
                <div className="migration-confirm-modal-manager-email">
                  {trans('merchant_migration_dialog_text_email')}: {email}
                </div>
              )}
              {phone && (
                <div className="migration-confirm-modal-manager-phone">
                  {trans('merchant_migration_dialog_text_phone')}: {phone}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </Fragment>
  );

  const renderForManager = () => (
    <div className="migration-confirm-modal-tip-wrapper">
      {trans('merchant_migration_dialog_text_toAchieve')}
      <ul className="migration-confirm-modal-tips">
        <li className="migration-confirm-modal-tip">
          {trans('merchant_migration_dialog_text_agreePolicy')}
          <span className="migration-confirm-modal-tip-wraning">
            {' '}
            {trans('merchant_migration_dialog_text_agreePolicyDate')}
          </span>
        </li>
        {migrateAction === MIGRATE_ACTION.BIND_PHONE && (
          <li className="migration-confirm-modal-tip">
            {trans('merchant_migration_dialog_text_bindPhoneNumber')}
            <span className="migration-confirm-modal-tip-wraning">
              {trans('merchant_migration_dialog_text_notBound')}
            </span>
          </li>
        )}
      </ul>
    </div>
  );

  const renderFooter = () => (
    <div className="migration-confirm-modal-footer">
      <div
        className={`migration-confirm-modal-agree-box${
          isReaded ? ' checked' : ''
        }`}
      >
        <NowCheckbox
          name={
            <span>
              {trans('merchant_migration_dialog_text_haveReadAndAgree')}{' '}
              <a
                href="https://resource.foody.vn/web/merchant-account-bind-announcement-user-policy.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                {trans('merchant_migration_dialog_text_userTC')}
              </a>{' '}
              {trans('merchant_migration_dialog_text_and')}{' '}
              <a
                href="https://resource.foody.vn/web/merchant-private-policy.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                {trans('merchant_migration_dialog_text_privacyPolicy')}
              </a>
              {trans('service_fee_message_3')}
            </span>
          }
          value={isReaded}
          onChange={e => setIsReaded(e.target.checked)}
        />
      </div>

      <button
        className="migration-confirm-modal-confirm-button btn btn-submit"
        disabled={!isReaded}
        onClick={onConfirm}
      >
        {migrateAction === MIGRATE_ACTION.BIND_PHONE
          ? trans('merchant_migration_dialog_btn_confirmAndBind')
          : trans('merchant_migration_dialog_btn_confirm')}
      </button>
    </div>
  );

  const renderConfirmModal = () => (
    <div className="migration-confirm-modal">
      <div className="migration-confirm-modal-header">
        <img
          className="migration-confirm-modal-mail-bg"
          src={MailBoxBgIcon}
          alt=""
        />
        <img
          className="migration-confirm-modal-mail"
          src={MailBoxIcon}
          alt=""
        />
        <div className="migration-confirm-modal-title">
          {trans('merchant_migration_dialog_text_upgradeTitle')}
        </div>
        <div className="migration-confirm-modal-shope-name">
          <span className="migration-confirm-modal-shope-label">
            {trans('merchant_migration_dialog_text_shopeeName')}:
          </span>
          {restaurantName}
        </div>
        <div className="migration-confirm-modal-shope-id">
          <span className="migration-confirm-modal-shope-label">
            {trans('merchant_migration_dialog_text_shopeeID')}:
          </span>
          {restaurantId}
        </div>
      </div>

      <div className="migration-confirm-modal-body">
        <div className="migration-confirm-modal-reason">
          {trans('merchant_migration_dialog_text_reason')}
        </div>
        {migrateAction === MIGRATE_ACTION.NOTICE_MANAGER
          ? renderForStaff()
          : renderForManager()}
      </div>

      {migrateAction !== MIGRATE_ACTION.NOTICE_MANAGER && renderFooter()}
    </div>
  );

  return (
    <Fragment>
      <MigrationModal
        className={
          migrateAction === MIGRATE_ACTION.NOTICE_MANAGER
            ? 'migration-staff-modal-content'
            : undefined
        }
        zIndex={2}
        closable={closable}
        isOpen={isOpen}
        content={renderConfirmModal()}
        onClose={handleClose}
      />
      <MigrationSettingModal
        setting="wraning"
        isOpen={isManagerWranOpen}
        title={trans('merchant_migration_simpleDialog_text_[title]dealWran')}
        content={trans(
          'merchant_migration_simpleDialog_text_[content]dealWran',
        )}
        confirmText={trans('merchant_migration_simpleDialog_btn_deal')}
        cancelText={trans('merchant_migration_simpleDialog_btn_later')}
        onConfirm={handleManagerWranConfirm}
        onCancel={handleManagerWranCancel}
      />
      <MigrationSettingModal
        setting="wraning"
        isOpen={isStaffWranOpen}
        title={trans('merchant_migration_simpleDialog_text_[title]tellManager')}
        content={trans(
          'merchant_migration_simpleDialog_text_[content]tellManager',
        )}
        confirmText={trans('merchant_migration_simpleDialog_btn_ok')}
        onConfirm={handleStaffWranConfirm}
      />
      <MigrationSettingModal
        setting="success"
        isOpen={isConfirmOpen}
        title={trans(
          'merchant_migration_simpleDialog_text_[title]confirmSuccessfully',
        )}
        content={trans(
          'merchant_migration_simpleDialog_text_[content]confirmSuccessfully',
        )}
        confirmText={trans('merchant_migration_simpleDialog_btn_ok')}
        onConfirm={handleConfirmSuccessConfirm}
      />
    </Fragment>
  );
});

MigrationConfirmModal.displayName = 'MigrationConfirmModal';

export default MigrationConfirmModal;



// WEBPACK FOOTER //
// ./foody/src/components/migration-confirm/MigrationConfirmModal.jsx